module.exports = __webpack_public_path__ + "static/header-image@2x-7e96f6dfeca7b84c641794e3d2f40fd8.png";